import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  description?: ReactNode;
  breadcrumbs?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({
  title,
  subtitle,
  description,
  breadcrumbs,
  actions,
  className,
}: PageHeaderProps) {
  return (
    <div className={cn('mb-6', className)}>
      {breadcrumbs && (
        <div className="mb-3 text-sm text-muted-foreground">
          {breadcrumbs}
        </div>
      )}
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0 max-w-2xl">
          {subtitle && (
            <p className="text-[11px] font-medium uppercase tracking-wider text-muted-foreground mb-1.5">
              {subtitle}
            </p>
          )}
          <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-foreground leading-[1.2] mb-2">
            {title}
          </h1>
          {description && (
            <p className="text-sm text-muted-foreground">
              {description}
            </p>
          )}
        </div>
        {actions && (
          <div className="flex items-center gap-2 flex-shrink-0">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}

